import { render, staticRenderFns } from "./u-icon.vue?vue&type=template&id=77f499e0&scoped=true"
import script from "./u-icon.vue?vue&type=script&lang=js"
export * from "./u-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f499e0",
  null
  
)

export default component.exports